import React from 'react';

export default function FooterLinks({ title, items }) {
  return (
    <div>
      <h4 className="text-white font-semibold mb-4">{title}</h4>
      <ul className="space-y-2 text-sm">
        {items.map((l) => (
          <li key={l.id || l.href}>
            <a href={l.href} className="hover:text-white transition-colors">{l.label}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
